import React from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

const Auth = ({ children }) => {
  const { autenticado } = useAuth();

  if (autenticado === null) {
    return null;
  }

  return autenticado ? children : <Navigate to="/login" />;
};

export default Auth;
